import React from 'react';
import styles from './styles.module.scss';

export const RequiredFieldErrorBar = ({
  displayString,
}: {
  displayString?: string;
}) => {
  const text = displayString || '* Please complete all required fields';
  const classNames = [
    styles.RequiredFieldBackground,
    styles.RequiredFieldText,
    styles.RequiredFieldNarrowPadding,
  ].join(' ');

  return <div className={classNames}>{text}</div>;
};
